import { useEffect, useState } from "react";
import { Box, Grid } from "@chakra-ui/react";
import { useScroll } from "framer-motion";
import { MotionBox } from "utils/motion";
import Trans from "components/base/Trans";

const SCROLL_THRESHOLD = 40;

const indicatorVariants = {
  scrolling: {
    y: [0, 80, 80, 0, 0],
    opacity: [1, 1, 0, 0, 1],
    transition: {
      duration: 3,
      delay: 3,
      times: [0, 0.3, 0.35, 0.5, 1],
      repeatDelay: 2,
      ease: "easeOut",
      loop: Infinity,
    },
  },
};

const containerVariants = {
  visible: { y: 0, opacity: 1, transition: { delay: 2.4, duration: 0.8 } },
  hidden: { y: -40, opacity: 0 },
};

const ScrollHint = (props) => {
  const { scrollY } = useScroll();
  const [isAtTop, setIsAtTop] = useState(true);

  useEffect(
    () =>
      scrollY.on("change", (y) => {
        if (y > SCROLL_THRESHOLD && isAtTop) setIsAtTop(false);
        if (y <= SCROLL_THRESHOLD && !isAtTop) setIsAtTop(true);
      }),
    [isAtTop, scrollY],
  );

  return (
    <MotionBox
      variants={containerVariants}
      initial="hidden"
      animate={isAtTop ? "visible" : "hidden"}
      {...props}
    >
      <Grid templateColumns="1fr 2px" alignItems="start" gap={6}>
        <Box
          fontSize="xs"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing="enormous"
          color="white"
        >
          <Trans id="LBL_CTA_SCROLL_DOWN" />
        </Box>

        <Box width="2px" height={32} bg="scrollTrack">
          <MotionBox
            variants={indicatorVariants}
            animate="scrolling"
            bg="white"
            width="2px"
            height={10}
            boxShadow="0 2px 10px 0 #ffffff"
          />
        </Box>
      </Grid>
    </MotionBox>
  );
};

export default ScrollHint;
